// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nif: CountryValidator<"FR"> = createValidator(
  "fr.nif",
  74,
);

export default nif;
export const compact = nif.compact;
export const format = nif.format;
export const validate = nif.validate;
export const generate = (): string =>
  nif.generate?.() ??
  (() => {
    throw new Error(
      "Validator fr.nif cannot generate values",
    );
  })();
